import { useQuery } from "@tanstack/react-query";
import { statisticsRepository } from "@/config/dataSource";
import type { RankingScope } from "@/modules/leagues/types/ranking";

export function useRanking(leagueId: string | undefined, scope: RankingScope, roundOrMonth?: number | string) {
  return useQuery({
    queryKey: ["ranking", leagueId ?? "unknown", scope, roundOrMonth ?? "default"],
    queryFn: () => statisticsRepository.getRanking(leagueId as string, scope, roundOrMonth),
    // "Rodada" PRECISA saber qual rodada antes de buscar qualquer coisa —
    // sem essa trava, a busca disparava direto na primeira renderização
    // com a rodada ainda indefinida (0 pts pra todo mundo, corrigindo
    // sozinha só depois, de forma inconsistente — bug relatado: "às vezes
    // abre com 0, às vezes não carrega"). "Geral" e "Mês" sempre têm um
    // valor válido desde o início, não precisam dessa trava.
    enabled: Boolean(leagueId) && (scope !== "rodada" || roundOrMonth !== undefined),
  });
}
